import styled from "@emotion/styled";
import { FaRegTrashCan } from "react-icons/fa6";

const ImageThumb = (props) => {
  const {
    elementKey,
    imageUrl,
    thumbUrl,
    loading,
    removeImage,
    config,
    type,
    fileName,
  } = props;

  const onClickRemove = (e) => {
    e.preventDefault();
    removeImage(e);
  };

  return (
    <StyledImportedImage config={config}>
      <p className={"image-name"}>{fileName}</p>
      {loading && (
        <div className={"loading-overlay"}>
          <i className={"fa fa-spinner fa-spin"} />
        </div>
      )}
      {removeImage && (
        <div className={"remove-image"} onClick={onClickRemove}>
          <FaRegTrashCan />
        </div>
      )}
    </StyledImportedImage>
  );
};

export default ImageThumb;

const StyledImportedImage = styled.div`
  border-bottom: 0.1em solid;
  border-color: ${(props) => props.config.colors.BLACK.B10};
  padding-bottom: 8px;
  display: flex;
  justify-content: space-between;
  padding-left: 15px;
  padding-right: 15px;
  margin-top: 15px;

  .image-name {
    font-family: "Sarabun";
    color: ${(props) => props.config.colors.BRAND.DARK};
    font-size: 16px;
    font-weight: 400;
  }

  .remove-image {
    cursor: pointer;
    color: ${(props) => props.config.colors.BRAND.ERROR};
  }
`;

const StyledImageThumb = styled.a`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => (props.type === "background" ? "100%" : "100px")};
  height: ${(props) => (props.type === "background" ? "100%" : "100px")};
  text-align: center;
  background: ${(props) => props.config.themeLayout?.imageBackground};

  .loading-overlay {
    position: absolute;
    background: rgba(255, 255, 255, 0.8);
    width: 100%;
    height: 100%;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .remove-image {
    position: absolute;
    z-index: 2;
    top: 2px;
    right: 2px;
    width: 1em;
    height: 1em;
    text-align: center;
    border-radius: 1em;
    font-size: 20px;
    font-weight: bold;
    line-height: 18px;
    color: ${(props) => props.config?.themeLayout?.link};
    background: ${(props) => props.config?.themeLayout?.background};
    cursor: pointer;
    user-select: none;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2);

    &:hover {
      color: ${(props) => props.config?.themeLayout?.background};
      background: ${(props) => props.config?.themeLayout?.link};
    }
  }

  &:not(:last-of-type) {
    margin-right: 15px;
  }

  img {
    max-width: 100px;
    max-height: 100px;
  }

  .image-background {
    background: url(${(props) => props.thumbUrl});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 10px;
    width: 100%;
    height: 100%;
    min-height: 100px;
  }
`;
